module.exports = __webpack_public_path__ + "static/szokala-0c371bccf1f6ba040979bd8507bd9721.jpg";